export const apiBasePath = process.env.REACT_APP_DOCTUSTECH_API_URL;
